import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLoadingFull = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 22 22",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M0 11c0 6.075 4.925 11 11 11s11-4.925 11-11S17.075 0 11 0 0 4.925 0 11m19.249 0A8.249 8.249 0 1 1 2.75 11a8.249 8.249 0 0 1 16.498 0"
	})
});
export default SvgLoadingFull;
